module.exports = __webpack_public_path__ + "img/202307_01.988b66db.jpg";